"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const params_1 = require("./params");
exports.default = {
    /**
     * Return access_token from sources in order:
     * 1. query params
     * 2. localStorage
     *
     * @returns {string | null} string containing access_token or null
     */
    getAccessToken() {
        return utils_1.getParam(params_1.Param.ACCESS_TOKEN);
    },
    /**
     * Return api_token from sources in order:
     * 1. query params
     * 2. localStorage
     *
     * @returns {string | null} string containing api_token or null
     */
    getApiToken() {
        return utils_1.getParam(params_1.Param.API_TOKEN);
    },
    /**
     * Return environment from sources in order:
     * 1. query params
     * 2. localStorage
     *
     * @returns {string | null} string containing environment or null
     */
    getEnvironment() {
        return utils_1.getParam(params_1.Param.ENVIRONMENT);
    },
    /**
     * Return subdomain from sources in order:
     * 1. query params
     * 2. path
     * 3. localStorage
     *
     * @returns {string | null} string containing subdomain or null
     */
    getSubdomain() {
        const subdomain = {
            query: utils_1.getParamFromQuery(window.location.search, params_1.Param.SUBDOMAIN),
            path: utils_1.getSubdomainFromPath(window.location.pathname),
            localStorage: utils_1.getParamFromLocalStorage(params_1.Param.SUBDOMAIN)
        };
        if (subdomain.query) {
            return subdomain.query;
        }
        else if (subdomain.path) {
            return subdomain.path;
        }
        else if (subdomain.localStorage) {
            return subdomain.localStorage;
        }
        else {
            return null;
        }
    }
};
//# sourceMappingURL=index.js.map